import { Route, Navigate, useLocation, useParams } from 'react-router-dom';

function LegacyAgriNewsRedirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/plant-protection-news\/?/, '');
  const target = rest ? `/agri-news/${rest}` : '/agri-news';
  return <Navigate to={`${target}${location.search}`} replace />;
}

function GrowthModelDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={`/production/crop/models/detail/${id}`} replace />;
}

function GrowthModelParamRedirect() {
  const { id } = useParams();
  return <Navigate to={`/production/crop/models/parameter-config/${id}`} replace />;
}

/** 旧路�?�?标准入口（第六批路由收敛 + 第一�?第二期迁移归并） */
export function getLegacyRedirectRoutes() {
  return (
    <>
      <Route path="/knowledge" element={<Navigate to="/knowledge-base" replace />} />
      <Route path="/plant-protection-mall" element={<Navigate to="/mall" replace />} />
      <Route path="/asset-management" element={<Navigate to="/production/land/asset-management" replace />} />
      <Route path="/mall-statistics" element={<Navigate to="/system-management/mall-statistics" replace />} />
      <Route path="/statistics/mall" element={<Navigate to="/system-management/mall-statistics" replace />} />
      <Route path="/my-plant-protection/sales-statistics" element={<Navigate to="/production/land/business-analysis" replace />} />
      <Route path="/my-plant-protection/data-statistics" element={<Navigate to="/production/land/business-analysis" replace />} />
      <Route path="/my-plant-protection/economic-statistics" element={<Navigate to="/production/land/business-analysis" replace />} />
      <Route path="/my-plant-protection/economic-analysis" element={<Navigate to="/production/land/business-analysis" replace />} />
      <Route path="/production/crop/growth/benefit-evaluation" element={<Navigate to="/production/land/business-analysis" replace />} />

      <Route path="/my-plant-protection/field-operation" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/my-plant-protection/field-task" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/my-plant-protection/nav_field_operations" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/field-work-overview" element={<Navigate to="/production/field-work" replace />} />

      <Route path="/my-plant-protection/expert-advice" element={<Navigate to="/agri-news/expert-advice" replace />} />
      <Route path="/my-plant-protection/seasonal-guidance" element={<Navigate to="/agri-news/seasonal-guidance" replace />} />

      <Route path="/my-plant-protection/weather-data" element={<Navigate to="/weather-agronomy/weather-data" replace />} />
      <Route path="/my-plant-protection/disaster-warning" element={<Navigate to="/weather-agronomy/disaster-warning" replace />} />
      <Route path="/my-plant-protection/local-climate" element={<Navigate to="/weather-agronomy/local-climate" replace />} />
      <Route path="/my-plant-protection/intervention-plans" element={<Navigate to="/weather-agronomy/intervention-plans" replace />} />

      <Route path="/plant-protection-inquiry" element={<Navigate to="/ai-service" replace />} />
      <Route path="/plant-protection-news" element={<Navigate to="/agri-news" replace />} />
      <Route path="/plant-protection-news/*" element={<LegacyAgriNewsRedirect />} />

      <Route path="/calendar" element={<Navigate to="/production/field-work/calendar" replace />} />
      <Route path="/growth-model/list" element={<Navigate to="/production/crop/models/list" replace />} />
      <Route path="/growth-model/ai-modeling" element={<Navigate to="/production/crop/models/ai-modeling" replace />} />
      <Route path="/growth-model/detail/:id" element={<GrowthModelDetailRedirect />} />
      <Route path="/growth-model/parameter-config/:id" element={<GrowthModelParamRedirect />} />
      <Route path="/my-plant-protection/plant-growth-model" element={<Navigate to="/production/crop/models/list" replace />} />
      <Route path="/my-plant-protection/crop-model" element={<Navigate to="/production/crop/models/list" replace />} />
      <Route path="/production/crop-model" element={<Navigate to="/production/crop/models/list" replace />} />

      {/* ????????? ? ???? */}
      <Route path="/user-management" element={<Navigate to="/system-management/user" replace />} />
      <Route path="/role" element={<Navigate to="/system-management/role" replace />} />
      <Route path="/permission" element={<Navigate to="/system-management/permission" replace />} />
      <Route path="/user-role" element={<Navigate to="/system-management/user-role" replace />} />
      <Route path="/role-permission" element={<Navigate to="/system-management/role-permission" replace />} />
      <Route path="/page-permission" element={<Navigate to="/system-management/page-permission" replace />} />
      <Route path="/organization" element={<Navigate to="/system-management/organization" replace />} />
      <Route path="/operation-log" element={<Navigate to="/system-management/operation-log" replace />} />
      <Route path="/agricultural-material" element={<Navigate to="/asset-management/agricultural-material" replace />} />
    </>
  );
}
